export default "__VITE_ASSET__COA8lLhh__"